import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AadhaarBasedAuthenticationService } from "../../shared/services/aadhaar/aadhaar.service";
import { CoreService, AuthenticationService, StoreService } from "../../shared/services";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
    selector: 'app-aadhaar-details',
    templateUrl: "./aadhaar-details.component.html",
    styleUrls: ["./aadhaar-details.component.scss"],
})

export class AadhaarDetailsComponent implements OnInit {
    
    userData: any = null;
    isLoading: boolean = true;
    profileImageUrl: SafeUrl | string = 'assets/default-avatar.png';
    headerData: any;
    storeSub: any;

    constructor(
        private aadhaarService: AadhaarBasedAuthenticationService,
        private router: Router,
        private coreService: CoreService,
        private authService: AuthenticationService,
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        private store: StoreService
    ) {}

    ngOnInit(){
        this.storeSub = this.store.getSett().subscribe(data => {
            this.headerData = data; 
        });
        // this.aadhaarService.getAadhaarDetails()

        // const rawQueryParams = window.location.search;
        // const urlParams = new URLSearchParams(rawQueryParams)

        // console.log("rawQueryParams", rawQueryParams)
        // console.log("urlParams", urlParams)

        // const client_id = urlParams.get("client_id")
        // const status = urlParams.get("status")
        // const state = urlParams.get("state")

        // console.log("client_id", client_id)
        // console.log("status", status)
        // console.log("state", state)

        this.isLoading = true;
        this.aadhaarService.getAadhaarDetails().subscribe({
            next: (res: any) => {
                console.log("Aadhaar Details Response", res);
                if (res && res.data) {
                    this.userData = res.data;
                    this.loadProfileImage();
                }
                const user = this.authService.getUserDetails()
                user.isAadhaarVerified = true;

                this.authService.saveLogin(user)
                this.isLoading = false;
            },
            error: (err) => {
                console.error("Error fetching Aadhaar details", err);
                this.isLoading = false;
                alert("Failed to fetch Aadhaar profile details.");
                this.router.navigate(['/home']);
            }
        });
    }
    
    continueToDashboard(): void {
        this.router.navigate(['/candidate']);
    }

    loadProfileImage(): void {
        if (!this.userData || !this.userData.profileImage) {
            return;
        }
        
        const url = this.coreService.getRootPath() + "/document/id/" + this.userData.profileImage;
        
        // Fetch as blob so the HTTP Interceptor automatically attaches the 'token' header
        this.http.get(url, { responseType: 'blob' }).subscribe({
            next: (blob) => {
                const objectUrl = URL.createObjectURL(blob);
                this.profileImageUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
            },
            error: (err) => {
                console.error("Failed to load profile image", err);
                // Keeps the default avatar on failure
            }
        });
    }

    ngOnDestroy() {
        if (this.storeSub) {
            this.storeSub.unsubscribe();
        }
    }

    getFirstStyles() {
        var setting = {};
        if (this.headerData && this.headerData.data) {
            setting = {
                'background-color': this.headerData.data.settings.header.firstoption ? this.headerData.data.settings.header.firstoption : '#001f3f',
                'color': 'white'
            }
        }
        return setting;
    }

    getSecondStyles() {
        var setting = {};
        if (this.headerData && this.headerData.data) {
            setting = {
                'background-color': this.headerData.data.settings.header.secondoption ? this.headerData.data.settings.header.secondoption : '#117a8b',
                'color': 'white'
            }
        }
        return setting;
    }
    
}